const ownersOffices = {
  header: 'Кабинеты собственников',
  items: [
    {
      title: 'Настройки',
      list: [
        {
          name: 'Настройки ЛК и мобильного приложения',
          route: { name: 'MobileSettings' },
          permission: {
            controller: 'Mobile',
            method: 'Settings',
            action: 'Edit'
          }
        },
        {
          name: 'Настройки автоснятия показаний ИПУ (запрета приема показаний)',
          route: { name: 'MeterAutoGettingValues' },
          permission: {
            controller: 'MeterAutoGettingValues',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Дома с запретом создания заявок',
          route: { name: 'SupportDeniedHouses' },
          permission: {
            controller: 'SupportDeniedHouses',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Настройки запрета приема показаний по объему',
        //   route: { name: 'MeterValuesDifferencesLimitsSettings' },
        //   permission: {
        //     controller: 'MeterValuesDifferencesLimitsSettings',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Задачи по отправке отчетов',
          route: { name: 'OwnersOfficesTasksToSendReports' },
          permission: {
            controller: 'TasksToSendReports',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Организации',
          route: { name: 'OwnersOfficesCompanyProfile' },
          permission: {
            controller: 'CompanyProfile',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Настройки пробития чеков',
        //   route: { name: 'PaycheckSettingsSet' },
        //   permission: {
        //     controller: 'PaycheckSettingsSet',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Настройки алиасов',
          route: { name: 'AliasSpecificSettings' },
          permission: {
            controller: 'AliasSpecific',
            method: 'Settings',
            action: 'Edit'
          }
        },
        {
          name: 'Лимиты задержки передачи показаний',
          route: { name: 'MeterValuesSendingDelayLimits' },
          permission: {
            controller: 'MeterValuesSendingDelayLimits',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Платежные агенты',
          route: { name: 'PaymentAgents' },
          permission: {
            controller: 'PaymentAgents',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Списки собственников',
      list: [
        {
          name: 'Дивизионы групп районов',
          route: { name: 'OwnersOfficesDistrictDivisions' },
          permission: {
            controller: 'DistrictDivisions',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Группы районов',
          route: { name: 'OwnersOfficesGroupsOfDistricts' },
          permission: {
            controller: 'GroupsOfDistricts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Районы',
          route: { name: 'OwnersOfficesHomeGroups' },
          permission: {
            controller: 'HomeGroups',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Дома',
          route: { name: 'OwnersOfficesHouses' },
          permission: {
            controller: 'Houses',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Помещения',
          route: { name: 'OwnersOfficesPremises' },
          permission: {
            controller: 'Premises',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Парковки',
          route: { name: 'Parkings' },
          permission: {
            controller: 'Parking',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Лицевые счета',
          route: { name: 'OwnersOffices.Accounts' },
          permission: {
            controller: 'Accounts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Мобильные пользователи',
          route: { name: 'OwnersOffices.MobileAccounts' },
          permission: {
            controller: 'MobileAccounts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Подключаемые лицевые счета при регистрации',
          route: { name: 'OwnersOfficesMobileAutoAddAccounts' },
          permission: {
            controller: 'MobileAutoAddAccounts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Устройства',
          route: { name: 'OwnersOfficesMobileAccountDevices' },
          permission: {
            controller: 'MobileAccountDevices',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Индивидуальные приборы учета',
        //   route: { name: 'Meters' },
        //   permission: {
        //     controller: 'Meters',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Показания индивидуальных ПУ',
          route: { name: 'MeterValues' },
          permission: {
            controller: 'MeterValues',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Поверки индивидуальных ПУ',
          route: { name: 'MeterVerifications' },
          permission: {
            controller: 'MeterVerifications',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Общедомовые приборы учета',
        //   route: { name: 'HouseMeters' },
        //   permission: {
        //     controller: 'HouseMeters',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Показания общедомовых ПУ',
          route: { name: 'HouseMeterValues' },
          permission: {
            controller: 'HouseMeterValues',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Поверки общедомовых ПУ',
          route: { name: 'HouseMeterVerifications' },
          permission: {
            controller: 'HouseMeterValues',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Заявки на поверку ИПУ',
          route: { name: 'MeterRecheckRequests' },
          permission: {
            controller: 'MeterRecheckRequests',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Квитанции',
        //   route: { name: 'OwnersOfficesBills' },
        //   permission: {
        //     controller: 'Bills',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        // {
        //   name: 'Квитанции по долгам',
        //   route: { name: 'DebtBills' },
        //   permission: {
        //     controller: 'DebtBills',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Центры начислений',
          route: { name: 'BillingCenters' },
          permission: {
            controller: 'BillingCenters',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Результаты рассылки квитанций',
          route: { name: 'SentBills' },
          permission: {
            controller: 'NotificationSendLogs',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Поставщики услуг',
          route: { name: 'ServiceSuppliers' },
          permission: {
            controller: 'ServiceSuppliers',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Поставщики услуг по домам',
        //   route: { name: 'HouseServiceSuppliers' },
        //   permission: {
        //     controller: 'HouseServiceSuppliers',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Черный список номеров телефона',
          route: { name: 'BlackListPhones' },
          permission: {
            controller: 'BlackListPhones',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Обращения через ЛК',
      list: [
        // {
        //   name: 'Уведомления',
        //   route: { name: 'Announcements' },
        //   permission: {
        //     controller: 'Announcements',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        // {
        //   name: 'Дерево решений по тех. поддержке',
        //   route: { name: 'TechnicalSupportHelpTree' },
        // },
      ]
    },
    {
      title: 'Интеграции с ИС',
      list: [
        // {
        //   name: 'Очередь заданий на загрузку',
        //   route: { name: 'RequestQueryReport' }
        // },
        {
          name: 'Сводный отчет по задачам ГИС',
          route: { name: 'GisExchangeTasksReport' },
          permission: {
            controller: 'GisExchangeTasksReport',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Настройки обмена данными',
        //   route: { name: 'DataExchangeSettings' },
        //   controllerName: 'Site',
        // },
        // {
        //   name: 'Настройка правил обмена данными',
        //   route: { name: 'DataExchangeSettings' },
        // },
        // {
        //   name: 'Правила обработки данных',
        //   route: { name: 'DataExchangeRules' },
        //   permission: {
        //     controller: 'DataExchangeRules',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        // {
        //   name: 'Поиск по очереди заданий',
        //   route: { name: 'RequestQueryReportProvider' },
        // },
        {
          name: 'Базы данных для синхронизации',
          route: { name: 'ExternalBase' },
          permission: {
            controller: 'ExternalBase',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Правила формирования адреса дома',
          route: { name: 'CommonSettings' },
          permission: {
            controller: 'Common',
            method: 'Settings',
            action: 'Edit'
          }
        },
        // {
        //   name: 'Общие настройки бонусной системы',
        //   route: { name: 'AliasSpecificSettings' },
        //   permission: {
        //     controller: 'AliasSpecific',
        //     method: 'Settings',
        //     action: 'Edit'
        //   }
        // },
        {
          name: 'Форматы номеров лицевых счетов',
          route: { name: 'AccountIdentFormats' },
          permission: {
            controller: 'AccountIdentFormats',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Монетизация',
      list: [
        {
          name: 'Группы доп. услуг',
          route: { name: 'AdditionalServiceGroups' },
          permission: {
            controller: 'AdditionalServiceGroups',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Доп. услуги',
        //   route: { name: 'AdditionalServices' },
        //   permission: {
        //     controller: 'AdditionalServices',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Магазины',
          route: { name: 'Shops' },
          permission: {
            controller: 'Shops',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Товары',
        //   route: { name: 'Goods' },
        //   permission: {
        //     controller: 'Goods',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Категории товаров',
          route: { name: 'GoodsCategories' },
          permission: {
            controller: 'GoodsCategories',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Прайс на доп услуги',
          route: { name: 'SupportAdditionalServices' },
          permission: {
            controller: 'SupportAdditionalServices',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Загрузка прайс листа',
          route: { name: 'ImportPriceList' },
          permission: {
            controller: 'ImportPriceList',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка Товаров и Магазинов для Маркетплейса',
          route: { name: 'ImportGoodsAndShops' },
          permission: {
            controller: 'ImportGoodsAndShops',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка доп.услуг для Маркетплейса',
          route: { name: 'ImportAdditionalServices' },
          permission: {
            controller: 'ImportAdditionalServices',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Рекламные баннеры',
          route: { name: 'Banners' },
          permission: {
            controller: 'Banners',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Платежи',
      list: [
        // {
        //   name: 'Платежи',
        //   route: { name: 'OwnersOfficesPaymentsInfo' },
        //   permission: {
        //     controller: 'PaymentsInfo',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Реестр оплат',
          route: { name: 'RegisterPayment' },
          permission: {
            controller: 'PaymentRegistries',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Реестр оплат страховок',
          route: { name: 'InsurancePaymentRegistries' },
          permission: {
            controller: 'InsurancePaymentRegistries',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Мобильные платежи',
          route: { name: 'MobilePayments' },
          permission: {
            controller: 'MobilePayments',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Акт об оказании услуг',
          route: { name: 'ActOfServiceProvisionReport' },
          permission: {
            controller: 'ActOfServiceProvisionReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Работа с реестром оплаты парковки',
          route: { name: 'ParkingPaymentRegistries' },
          permission: {
            controller: 'ParkingPaymentRegistries',
            method: 'Table',
            action: 'View'
          }
        },
      ]
    },
    {
      title: 'Отчеты',
      list: [
        {
          name: 'Информация по лицевому счету',
          route: { name: 'AccountInfoReport' },
          permission: {
            controller: 'AccountInfoReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Информация по домам',
          route: { name: 'HousesInfoReport' },
          permission: {
            controller: 'HousesInfoReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Выписка из лицевого счета',
          route: { name: 'AccountExtractReport' },
          permission: {
            controller: 'AccountExtractReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Выписка по дому',
          route: { name: 'HouseExtractReport' },
          permission: {
            controller: 'HouseExtractReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Выписка по организации',
          route: { name: 'CompanyExtractReport' },
          permission: {
            controller: 'CompanyExtractReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Проверка начислений и платежей (Услуги)',
          route: { name: 'AccountingAndPaymentReport' },
          permission: {
            controller: 'AccountingAndPaymentReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Проверка начислений и платежей (ЛС)',
          route: { name: 'AccountingAndPaymentByIdentReport' },
          permission: {
            controller: 'AccountingAndPaymentByIdentReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет о нарушении связанности данных',
          route: { name: 'CheckingReferenceIntegrityReport' },
          permission: {
            controller: 'CheckingReferenceIntegrityReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Имеющиеся показания по приборам учета',
          route: { name: 'MeterExistValuesReport' },
          permission: {
            controller: 'MeterExistValuesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Проверка квитанций',
          route: { name: 'CheckingBillsReport' },
          permission: {
            controller: 'CheckingBillsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Открытые ПУ по закрытым ЛС',
          route: { name: 'MetersOpenWhenAccountClosedReport' },
          permission: {
            controller: 'MetersOpenWhenAccountClosedReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по страхованию',
          route: { name: 'InsuranceReport' },
          permission: {
            controller: 'InsuranceReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Проверка заполнения ПУ',
          route: { name: 'CheckMetersProcessor' },
          permission: {
            controller: 'CheckMetersProcessor',
            method: 'Processor',
            action: 'Perform'
          }
        },
        {
          name: 'Сравнение долгов Сбер и НИЦ',
          route: { name: 'SberDebtsCompareProcessor' },
          permission: {
            controller: 'SberDebtsCompareProcessor',
            method: 'Processor',
            action: 'Perform'
          }
        },
        {
          name: 'Отчёт по заказанным арендам машиномест',
          route: { name: 'ParkingRentsOrdersReport' },
          permission: {
            controller: 'ParkingRentsOrdersReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по реестру оплат парковок',
          route: { name: 'PaymentsRegistryParkingReport' },
          permission: {
            controller: 'PaymentsRegistryParkingReport',
            method: 'Report',
            action: 'View'
          }
        },
      ]
    },
    {
      title: 'Аналитические отчеты',
      list: [
        {
          name: 'Анализ использования мобильного приложения',
          route: { name: 'MobileUsersAnalisisReport' },
          permission: {
            controller: 'MobileUsersAnalisisReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Показания приборов учета',
          route: { name: 'MeterValuesReport' },
          permission: {
            controller: 'MeterValuesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Показания ОДПУ, переданные через МП',
          route: { name: 'HouseMeterValuesReceivedReport' },
          permission: {
            controller: 'HouseMeterValuesReceivedReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по QR-кодам приборов учета',
          route: { name: 'MetersQrCodesReport' },
          permission: {
            controller: 'MetersQrCodesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Статистика просмотров уведомлений',
          route: { name: 'MobileAnnouncementReport' },
          permission: {
            controller: 'MobileAnnouncementReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по реестру оплат',
          route: { name: 'PaymentsRegistryReport' },
          permission: {
            controller: 'PaymentsRegistryReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Динамика роста пользователей мобильного приложения',
          route: { name: 'MobileUsersInDynamicsReport' },
          permission: {
            controller: 'MobileUsersInDynamicsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Детальная статистика',
          route: { name: 'MobileDetailedStatisticsReport' },
          permission: {
            controller: 'MobileDetailedStatisticsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Сводная статистика',
          route: { name: 'MobileSummaryStatisticsReport' },
          permission: {
            controller: 'MobileSummaryStatisticsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Журнал авторизации',
          route: { name: 'SessionsLog' },
          permission: {
            controller: 'SessionsLog',
            method: 'Report',
            action: 'View',
          }
        },
        {
          name: 'Обращения с сайта',
          route: { name: 'CallbackRequestsReport' },
          permission: {
            controller: 'CallbackRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по пользователям',
          route: { name: 'MobileAccountsInfoReport' },
          permission: {
            controller: 'MobileAccountsInfoReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по лицевым счетам не привязанным к моб.аккаунтам',
          route: { name: 'IdentsWithoutMobileAccountReport' },
          permission: {
            controller: 'IdentsWithoutMobileAccountReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по мобильным платежам',
          route: { name: 'MobilePaymentsReport' },
          permission: {
            controller: 'MobilePaymentsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по чекам',
          route: { name: 'PaymentsVsPaychecksReport' },
          permission: {
            controller: 'PaymentsVsPaychecksReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по загруженным квитанциям',
          route: { name: 'LoadedReceiptsReport' },
          permission: {
            controller: 'LoadedReceiptsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по роботу по приему ППУ',
          route: { name: 'MeterValuesRobotReport' },
          permission: {
            controller: 'MeterValuesRobotReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по роботу по приему показаний',
          route: { name: 'RobotForMeterValuesReport' },
          permission: {
            controller: 'RobotForMeterValuesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по роботу-диспетчеру',
          route: { name: 'RobotRequestsReport' },
          permission: {
            controller: 'RobotRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Переходы на внешние ресурсы',
          route: { name: 'TransitionsToExternalResources' },
          permission: {
            controller: 'TransitionsToExternalResources',
            method: 'Report',
            action: 'View',
          }
        },
        {
          name: 'Отчет по подключенным лиц. счетам МОЕ',
          route: { name: 'MoeAccountsReport' },
          permission: {
            controller: 'MoeAccountsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Активные пользователи МП и ЛК',
          route: { name: 'MobileUsersActivityByPremisesReport' },
          permission: {
            controller: 'MobileUsersActivityByPremisesReport',
            method: 'Report',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Бонусная система',
      list: [
        {
          name: 'Параметры начислений',
          route: { name: 'BonusSystem' },
          permission: {
            controller: 'BonusSystem',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Бонусные программы',
          route: { name: 'BonusPrograms' },
          permission: {
            controller: 'BonusProgram',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по бонусам',
          route: { name: 'BonusCashFlowReport' },
          permission: {
            controller: 'BonusCashFlowReport',
            method: 'Report',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Опросы',
      list: [
        {
          name: 'Опросы и вопросы',
          route: { name: 'QuestionGroups' },
          permission: {
            controller: 'QuestionGroups',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по опросам',
          route: { name: 'QuestionsReport' },
          permission: {
            controller: 'QuestionsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Результаты опросов',
          route: { name: 'QuestionResultsReport' },
          permission: {
            controller: 'QuestionResultsReport',
            method: 'Report',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Загрузка из Excel и проверки',
      list: [
        {
          name: 'Загрузка дат ДРСО',
          route: { name: 'OwnersOfficesImportSupplyContractInfo' },
          permission: {
            controller: 'ImportSupplyContractInfo',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка ФИАС домов',
          route: { name: 'OwnersOfficesImportFias' },
          permission: {
            controller: 'ImportFias',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка адресов домов по ФИАС коду',
          route: { name: 'OwnersOfficesImportFiasAddress' },
          permission: {
            controller: 'ImportFiasAddress',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка выполняемых работ',
          route: { name: 'OwnersOfficesImportExecutingJobs' },
          permission: {
            controller: 'ImportExecutingJobs',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка приборов учета',
          route: { name: 'OwnersOfficesImportMeters' },
          permission: {
            controller: 'ImportMeters',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка показаний приборов учета',
          route: { name: 'OwnersOfficesImportMeterValues' },
          permission: {
            controller: 'ImportMeterValues',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка помещений',
          route: { name: 'OwnersOfficesImportPremises' },
          permission: {
            controller: 'ImportPremises',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Проверка загрузки квитанций ',
          route: { name: 'OwnersOfficesBillsCheck' },
          permission: {
            controller: 'BillsCheck',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка дел должников (расширенная)',
          route: { name: 'OwnersOfficesImportDebtCases' },
          permission: {
            controller: 'ImportDebtCases',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка GUID ДРСО',
          route: { name: 'OwnersOfficesImportSupplyContractGuids' },
          permission: {
            controller: 'ImportSupplyContractGuids',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка перечней и планов работ',
          route: { name: 'OwnersOfficesImportWorkLists' },
          permission: {
            controller: 'ImportWorkLists',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка домов',
          route: { name: 'OwnersOfficesImportHouses' },
          permission: {
            controller: 'ImportHouses',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка квитанций',
          route: { name: 'OwnersOfficesImportAccountDebtServices' },
          permission: {
            controller: 'ImportAccountDebtServices',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка квитанций расширенная',
          route: { name: 'OwnersOfficesImportBillsExtended' },
          permission: {
            controller: 'ImportBillsExtended',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка оплат',
          route: { name: 'OwnersOfficesImportPayments' },
          permission: {
            controller: 'ImportPayments',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка автоматически подключаемых лицевых счетов',
          route: { name: 'ImportMobileAutoAddAccounts' },
          permission: {
            controller: 'ImportMobileAutoAddAccounts',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка контактов по ЛС',
          route: { name: 'ImportAccountContacts' },
          permission: {
            controller: 'ImportAccountContacts',
            method: 'Import',
            action: 'Perform'
          }
        },
      ]
    },
    {
      title: 'Интернет-провайдеры',
      list: [
        {
          name: 'Интернет-провайдеры',
          route: { name: 'InternetProviders' },
          permission: {
            controller: 'InternetProviders',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Тарифы интернет-провайдеров',
          route: {
            name: 'InternetProvidersTariffs'
          },
          permission: {
            controller: 'InternetProvidersTariffs',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Подключенные тарифы интернет-провайдеров',
          route: {
            name: 'InternetProvidersTariffsConnected'
          },
          permission: {
            controller: 'InternetProvidersTariffs',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Обработки',
      list: [
        {
          name: 'Запуск звонков через UIS с уведомлением о поверке прибора учета',
          route: { name: 'MeterRecheckCallerProcessor' },
          permission: {
            controller: 'MeterRecheckCallerProcessor',
            method: 'Processor',
            action: 'Perform'
          }
        },
        {
          name: 'Генерация pdf-квитанций',
          route: { name: 'CreateBillsPdfProcessor' },
          permission: {
            controller: 'CreateBillsPdfProcessor',
            method: 'Processor',
            action: 'Perform'
          }
        },
        // ВЛОЖЕННЫЕ
        // {
        //   name: 'Загрузка данных о размере фондов капитального ремонта',
        //   route: { name: 'OwnersOffices.ImportCapitalFundSizeProcessor' },
        //   permission: {
        //     controller: 'ImportCapitalFundSizeProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        {
          name: 'Архивация приборов учета ИПУ списком из Excel',
          route: { name: 'ArchiveMetersByExcelProcessor' },
          permission: {
            controller: 'ArchiveMetersByExcelProcessor',
            method: 'Processor',
            action: 'Perform',
          }
        },
        {
          name: 'Архивация приборов учета ИПУ',
          route: { name: 'ArchiveMetersProcessor' },
          permission: {
            controller: 'Processor',
            method: 'ArchiveMetersProcessor',
            action: 'Perform',
          }
        },
        {
          name: 'Массовое закрытие ЛС списком из Excel',
          route: { name: 'CloseAccountsByExcelProcessor' },
          permission: {
            controller: 'Processor',
            method: 'CloseAccountsByExcelProcessor',
            action: 'Perform',
          }
        },
        {
          name: 'Массовое закрытие ЛС',
          route: { name: 'CloseAccountsProcessor' },
          permission: {
            controller: 'CloseAccountsProcessor',
            method: 'Processor',
            action: 'Perform',
          }
        },
        // {
        //   name: 'Настройки Робота',
        //   route: { name: 'RobotSettings' },
        //   permission: {
        //     controller: 'RobotSettings',
        //     method: 'Settings',
        //     action: 'View',
        //   }
        // },
        // {
        //   name: 'Обновить ИЖКУ по результатам обработки шаблона ЛС ТКО',
        //   route: { name: 'OwnersOffices.AccountFromTkoTemplateProcessor' },
        //   permission: {
        //     controller: 'AccountFromTkoTemplateProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Выгрузить ЛС/ЕЛС в CSV',
        //   route: { name: 'OwnersOffices.AccountsCsvFileProcessor' },
        //   permission: {
        //     controller: 'AccountsCsvFileProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Выгрузить ЛС/ЕЛС в Excel',
        //   route: { name: 'OwnersOffices.AccountsExcelFileProcessor' },
        //   permission: {
        //     controller: 'AccountsExcelFileProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Удалить квитанции за период',
        //   route: { name: 'BillsDeleteByPeriodProcessor' },
        //   permission: {
        //     controller: 'BillsDeleteByPeriodProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Создать лицевые счета для кап.ремонта',
        //   route: { name: 'OwnersOffices.CreateCRAccountsProcessor' },
        //   permission: {
        //     controller: 'CreateCRAccountsProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Удаление показаний за период',
        //   route: { name: 'DeleteMeterValuesByPeriodProcessor' },
        //   permission: {
        //     controller: 'DeleteMeterValuesByPeriodProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Выгрузить доп. информацию по домам (XLSX)',
        //   route: { name: 'OwnersOffices.ExportHousesToExcelProcessor' },
        //   permission: {
        //     controller: 'ExportHousesToExcelProcessor',
        //     method: 'Processor',
        //     action: 'Perform'
        //   }
        // },
        // {
        //   name: 'Выгрузить дома без ФИАС в CSV файл',
        //   route: { name: 'OwnersOffices.ExportHousesWithoutFiasProcessor' },
        //   permission: {
        //     controller: 'ExportHousesWithoutFiasProcessor',
        //     method: 'Processor',
        //     action: 'Perform'
        //   }
        // },
        // {
        //   name: 'Экспорт номеров помещений ГИС в Excel',
        //   route: { name: 'OwnersOffices.ExportPremiseGisNumberProcessor' },
        //   permission: {
        //     controller: 'ExportPremiseGisNumberProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Заполнить пустые типы услуг в квитанциях',
        //   route: { name: 'FillEmptyTypesServicesForBillsProcessor' },
        //   permission: {
        //     controller: 'FillEmptyTypesServicesForBillsProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Выгрузить ЛС ТКО',
        //   route: { name: 'OwnersOffices.FillTemplateTKOAccountsProcessor' },
        //   permission: {
        //     controller: 'FillTemplateTKOAccountsProcessor',
        //     method: 'Processor',
        //     action: 'Perform'
        //   }
        // },
        // {
        //   name: 'Выгрузить квитанции ТКО',
        //   route: { name: 'FillTemplateWithTkoBillsProcessor' },
        //   permission: {
        //     controller: 'FillTemplateWithTkoBillsProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Мастер создания дома',
        //   route: { name: 'OwnersOffices.HouseCreationMasterProcessor' },
        //   permission: {
        //     controller: 'HouseCreationMasterProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Загрузить ФИАСы',
        //   route: { name: 'OwnersOffices.HouseFiasesProcessor' },
        //   permission: {
        //     controller: 'HouseFiasesProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Заполнить шаблон по добавлению ОЖФ в договор ТКО(XLSX)',
        //   route: { name: 'OwnersOffices.HousesForTkoContractProcessor' },
        //   permission: {
        //     controller: 'HousesForTkoContractProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Изменение типа домов по кол-ву помещений',
        //   route: { name: 'OwnersOffices.HouseTypeByPremiseTypeProcessor' },
        //   permission: {
        //     controller: 'HouseTypeByPremiseTypeProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Загрузить доп. информацию по домам (XLSX)',
        //   route: { name: 'OwnersOffices.ImportHousesFromExcelProcessor' },
        //   permission: {
        //     controller: 'ImportHousesFromExcelProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Слияние услуги/ресурса',
        //   route: { name: 'MergeServiceOnBillsProcessor' },
        //   permission: {
        //     controller: 'MergeServiceOnBillsProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Удалить помещения, не привязанные к ЛС',
        //   route: { name: 'OwnersOffices.PremisesNotLinkedToAccountRemoveProcessor' },
        //   permission: {
        //     controller: 'PremisesNotLinkedToAccountRemoveProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Перезаполнение типов услуг в квитанциях',
        //   route: { name: 'RefillServiceTypesInBillsProcessor' },
        //   permission: {
        //     controller: 'RefillServiceTypesInBillsProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Обновление адресов домов',
        //   route: { name: 'OwnersOffices.UpdateHousesAddressesProcessor' },
        //   permission: {
        //     controller: 'UpdateHousesAddressesProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        // {
        //   name: 'Выгрузка оплат ТКО',
        //   route: { name: 'ExportTkoPaymentsInfoProcessor' },
        //   permission: {
        //     controller: 'ExportTkoPaymentsInfoProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
      ]
    },
  ]
};

const gis = {
  header: 'ГИС ЖКХ',
  items: [
    {
      title: 'Обмены с ГИС ЖКХ',
      list: [
        {
          name: 'Обмены с ГИС ЖКХ',
          route: { name: 'GisAutoTaskPack' },
          permission: {
            controller: 'GisAutoTaskPack',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Отчеты по ошибкам',
      list: [
        {
          name: 'Ошибки выгрузки ДРСО в ГИС ЖКХ в разрезе ОЖФ',
          route: { name: 'GISSupplyContractExchangeErrorsReport' },
          permission: {
            controller: 'GISSupplyContractExchangeErrorsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки ЛС в ГИС ЖКХ',
          route: { name: 'GISAccountExportErrorsReport' },
          permission: {
            controller: 'GISAccountExportErrorsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки ПД в ГИС ЖКХ',
          route: { name: 'GISBillExportErrorsReport' },
          permission: {
            controller: 'GISBillExportErrorsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки ИПУ в ГИС ЖКХ',
          route: { name: 'GISIndividualMeterExportErrorReport' },
          permission: {
            controller: 'GISIndividualMeterExportErrorReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки показаний ИПУ в ГИС ЖКХ',
          route: { name: 'GISIndividualMeterValueExportErrorReport' },
          permission: {
            controller: 'GISIndividualMeterValueExportErrorReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки ОДПУ в ГИС ЖКХ',
          route: { name: 'GISHouseMeterExportErrorReport' },
          permission: {
            controller: 'GISHouseMeterExportErrorReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки показаний ОДПУ в ГИС ЖКХ',
          route: { name: 'GISHouseMeterValueExportErrorReport' },
          permission: {
            controller: 'GISHouseMeterValueExportErrorReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки оплат в ГИС ЖКХ',
          route: { name: 'GISPaymentExportErrorReport' },
          permission: {
            controller: 'GISPaymentExportErrorReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Ошибки выгрузки квитирования в ГИС ЖКХ',
          route: { name: 'GISAcknowledgmentExportErrorsReport' },
          permission: {
            controller: 'GISAcknowledgmentExportErrorsReport',
            method: 'Report',
            action: 'View'
          }
        }
      ]
    },

    {
      title: 'Обмен с ОСЗН',
      list: [
        {
          name: 'Отчет по заявкам',
          route: { name: 'DebtRequestStatisticsReport' },
          permission: {
            controller: 'DebtRequestStatisticsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Статус помещений',
          route: { name: 'PremiseDebtInfoWithDoubt' },
          permission: {
            controller: 'PremiseDebtInfoWithDoubt',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Судебная задолженность',
          route: { name: 'PremiseDebtInfos' },
          permission: {
            controller: 'PremiseDebtInfos',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Запросы о наличии задолженности по ЖКУ',
          route: { name: 'GIS.DebtInfoRequests' },
          permission: {
            controller: 'DebtInfoRequests',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по должникам',
          route: { name: 'DebtorsReport' },
          permission: {
            controller: 'DebtorsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по запросам из ОСЗН по должникам',
          route: { name: 'DebtorsRequestsReport' },
          permission: {
            controller: 'DebtorsRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Задачи по отправке отчетов',
          route: { name: 'TasksToSendReports' },
          permission: {
            controller: 'TasksToSendReports',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по запросам сведений о должниках для ОСЗН (выгрузка в Excel)',
          route: { name: 'DebtorsRequestsCustomReportProcessor' },
          permission: {
          controller: 'DebtorsRequestsCustomReportProcessor',
            method: 'Processor',
            action: 'Perform',
          }
        },
      ]
    },
    {
      title: 'Отчеты по статистике',
      list: [
        {
          name: 'Общая статистика выгрузки в ГИС ЖКХ',
          route: { name: 'GISUploadStatisticReport' },
          permission: {
            controller: 'GISUploadStatisticReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Статистика выгрузки в ГИС ЖКХ по домам',
          route: { name: 'GISUploadStatisticByHouseReport' },
          permission: {
            controller: 'GISUploadStatisticByHouseReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Паспорт выгрузки в ГИС ЖКХ',
          route: { name: 'GISExportCommonStatisticsReport' },
          permission: {
            controller: 'GISExportCommonStatisticsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Статистика по организациям',
          route: { name: 'GisUploadStatisticByCompanyReport' },
          permission: {
            controller: 'GisUploadStatisticByCompanyReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Статистика по отозванным ПД',
          route: { name: 'WithdrawnBillsCountReport' },
          permission: {
            controller: 'WithdrawnBillsCountReport',
            method: 'Report',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Отчеты НПДО',
      list: [
        {
          name: 'Отчет о выгрузке счет-квитанций',
          route: { name: 'GISContractBillsReport' },
          permission: {
            controller: 'GISContractBillsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет о выгрузке по лицевым счетам',
          route: { name: 'GISContractIdentsReport' },
          permission: {
            controller: 'GISContractIdentsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет о выгрузке по приборам учета',
          route: { name: 'GISContractMetersReport' },
          permission: {
            controller: 'GISContractMetersReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет о передаче показаний приборов учета',
          route: { name: 'GISContractMetersValuesReport' },
          permission: {
            controller: 'GISContractMetersValuesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет об информации по запросам',
          route: { name: 'GISContractRequestsReport' },
          permission: {
            controller: 'GISContractRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет о выгрузке договоров',
          route: { name: 'GISContractsReport' },
          permission: {
            controller: 'GISContractsReport',
            method: 'Report',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Загрузка из Excel и проверки',
      list: [
        {
          name: 'Загрузка дат ДРСО',
          route: { name: 'ImportSupplyContractInfo' },
          permission: {
            controller: 'ImportSupplyContractInfo',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка ФИАС домов',
          route: { name: 'GisImportFias' },
          permission: {
            controller: 'GisImportFias',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка адресов домов по ФИАС коду',
          route: { name: 'ImportFiasAddress' },
          permission: {
            controller: 'ImportFiasAddress',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка выполняемых работ',
          route: { name: 'ImportExecutingJobs' },
          permission: {
            controller: 'ImportExecutingJobs',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка приборов учета',
          route: { name: 'ImportMeters' },
          permission: {
            controller: 'ImportMeters',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка показаний приборов учета',
          route: { name: 'ImportMeterValues' },
          permission: {
            controller: 'ImportMeterValues',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка помещений',
          route: { name: 'GisImportPremises' },
          permission: {
            controller: 'GisImportPremises',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка помещений и лицевых счетов (из двух файлов)',
          route: { name: 'GisImportPremisesFromTwoFiles' },
          permission: {
            controller: 'ImportPremisesFromTwoFiles',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Проверка загрузки квитанций ',
          route: { name: 'GisBillsCheck' },
          permission: {
            controller: 'GisBillsCheck',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка дел должников (расширенная)',
          route: { name: 'GisImportDebtCases' },
          permission: {
            controller: 'GisImportDebtCases',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка GUID ДРСО',
          route: { name: 'GisImportSupplyContractGuids' },
          permission: {
            controller: 'GisImportSupplyContractGuids',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка перечней и планов работ',
          route: { name: 'GisImportWorkLists' },
          permission: {
            controller: 'GisImportWorkLists',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка данных о размере фондов капитального ремонта',
          route: { name: 'ImportCapitalFundSizeProcessor' },
          permission: {
            controller: 'ImportCapitalFundSizeProcessor',
            method: 'Processor',
            action: 'Perform',
          }
        },
        {
          name: 'Загрузка домов',
          route: { name: 'GisImportHouses' },
          permission: {
            controller: 'GisImportHouses',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка квитанций',
          route: { name: 'GisImportAccountDebtServices' },
          permission: {
            controller: 'GisImportAccountDebtServices',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка квитанций расширенная',
          route: { name: 'GisImportBillsExtended' },
          permission: {
            controller: 'GisImportBillsExtended',
            method: 'Import',
            action: 'Perform'
          }
        },
        {
          name: 'Загрузка оплат',
          route: { name: 'GisImportPayments' },
          permission: {
            controller: 'GisImportPayments',
            method: 'Import',
            action: 'Perform'
          }
        }
      ]
    },
    {
      title: 'Новости для информирования граждан',
      list: [
        {
          name: 'Новости для информирования граждан',
          route: { name: 'GisNotifications' },
          permission: {
            controller: 'GisNotifications',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Справочники',
      list: [
        {
          name: 'Договоры пользования ОИ',
          route: { name: 'PublicPropertyContracts' },
          permission: {
            controller: 'PublicPropertyContracts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Объемы и качество КР и КУ',
          route: { name: 'CommunalSupplyInformation' },
          permission: {
            controller: 'CommunalSupplyInformation',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Информация о состоянии расчетов за КУ',
          route: { name: 'ResourceSettlement' },
          permission: {
            controller: 'ResourceSettlement',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Перерывы по коммунальным услугам',
          route: { name: 'ServiceInterruptions' },
          permission: {
            controller: 'ServiceInterruptions',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Плановые перерывы по коммунальным услугам',
          route: { name: 'OutageReport' },
          permission: {
            controller: 'OutageReport',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Страховые продукты',
          route: { name: 'InsuranceProducts' },
          permission: {
            controller: 'InsuranceProduct',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Сведения о размере платы',
          route: { name: 'ManagementContractPaymentsInfo' },
          permission: {
            controller: 'ManagementContractPaymentsInfo',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Информация о размере фондов КР',
          route: { name: 'CapitalRepairFundSizeInfo' },
          permission: {
            controller: 'CapitalRepairFundSizeInfo',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Тарифы на оплату коммунальных ресурсов',
          route: { name: 'CommunalResourcePaymentTariffs' },
          permission: {
            controller: 'TarifForPaymentOfCommunalResource',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Типы коммунальных услуг',
          route: { name: 'CommunalResourceTypes' },
          permission: {
            controller: 'CommunalResourceTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Типы жилищных услуг',
          route: { name: 'ServiceTypes' },
          permission: {
            controller: 'ServiceTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Коммунальные ресурсы',
          route: { name: 'CommunalResources' },
          permission: {
            controller: 'CommunalResources',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Договоры ресурсоснабжения',
          route: { name: 'SupplyContract' },
          permission: {
            controller: 'SupplyContract',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Добавление услуги и ресурса в предмет ДРСО на основе ресурса ИПУ',
        //   route: { name: 'SupplyContractSubjectsResourcePairCreateByMeterResourceProcessor' },
        //   permission: {
        //     controller: 'SupplyContractSubjectsResourcePairCreateByMeterResourceProcessor',
        //     method: 'Processor',
        //     action: 'Perform',
        //   }
        // },
        {
          name: 'Коммунальные услуги по домам УК/ТСЖ',
          route: { name: 'HouseReports' },
          permission: {
            controller: 'HouseReports',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Протоколы голосования',
          route: { name: 'VotingProtocols' },
          permission: {
            controller: 'VotingProtocols',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Коммунальные услуги по ДУ',
          route: { name: 'CommunalServices' },
          permission: {
            controller: 'CommunalServices',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Лицензии',
          route: { name: 'Licenses' },
          permission: {
            controller: 'Licenses',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Планы работ',
      list: [
        {
          name: 'Работы и услуги',
          route: { name: 'WorkServices' },
          permission: {
            controller: 'WorkServices',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Перечни работ',
          route: { name: 'WorkList' },
          permission: {
            controller: 'WorkList',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Планы работ',
          route: { name: 'WorkPlans' },
          permission: {
            controller: 'WorkPlans',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Фиксация планов',
          route: { name: 'WorkPlanCompleted' },
          permission: {
            controller: 'WorkPlanCompleted',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Платежные документы',
      list: [
        {
          name: 'Квитирование',
          route: { name: 'Acknowledgments' },
          permission: {
            controller: 'Acknowledgments',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Настройки',
      list: [
        {
          name: 'Настройки ГИС ЖКХ',
          route: { name: 'GisSettings' },
          permission: {
            controller: 'GisSettings',
            method: 'Settings',
            action: 'Edit'
          }
        },
        {
          name: 'Настройки ГИС ЖКХ соцзащита',
          route: { name: 'SocialSecuritySettings' },
          permission: {
            controller: 'SocialSecurity',
            method: 'Settings',
            action: 'Edit'
          }
        },
      ]
    },
    {
      title: 'Фильтры',
      list: [
        {
          name: 'Фильтры загрузки заявок ГИС / ЕДС',
          route: { name: 'ImportGisEdsRequestsFilters' },
          permission: {
            controller: 'ImportGisEdsRequestsFilters',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    // {
    //   title: 'Обработки', // ТОЛЬКО ВЛОЖЕННЫЕ
    //   list: [
    //     {
    //       name: 'Формирование файлов аудита',
    //       route: { name: 'AuditFilesProcessor' },
    //       permission: {
    //         controller: 'AuditFilesProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Связи для квитирования',
    //       route: { name: 'AcknowledgementProcessor' },
    //       permission: {
    //         controller: 'AcknowledgementProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Записать Guidы договоров в ЛС (найти лс по ОЖФ)',
    //       route: { name: 'AccountContractsGuidByObjectsProcessor' },
    //       permission: {
    //         controller: 'AccountContractsGuidByObjectsProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Записать Guidы договоров в ЛС (найти лс по № договора)',
    //       route: { name: 'AccountContractsGuidUpdateProcessor' },
    //       permission: {
    //         controller: 'AccountContractsGuidUpdateProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Заполнение договоров тарифами',
    //       route: { name: 'AddTariffOnSupplyContractProcessor' },
    //       permission: {
    //         controller: 'AddTariffOnSupplyContractProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Заполнение информации по КУ и КР на основе ПД',
    //       route: { name: 'FillCommunalSupplyInformationProcessor' },
    //       permission: {
    //         controller: 'FillCommunalSupplyInformationProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Создание недостающего договора на основе ДРСО',
    //       route: { name: 'SupplyContractsCreateProcessor' },
    //       permission: {
    //         controller: 'SupplyContractsCreateProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Обновить ОЖФ в договорах',
    //       route: { name: 'SupplyContractsObjectsUpdateProcessor' },
    //       permission: {
    //         controller: 'SupplyContractsObjectsUpdateProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Расторгнуть ДРСО по закрытым л/сч',
    //       route: { name: 'SupplyContractsTerminateProcessor' },
    //       permission: {
    //         controller: 'SupplyContractsTerminateProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //     {
    //       name: 'Обновить услуги на основе квитанций',
    //       route: { name: 'SupplyContractSubjectsProcessor' },
    //       permission: {
    //         controller: 'SupplyContractSubjectsProcessor',
    //         method: 'Processor',
    //         action: 'Perform',
    //       }
    //     },
    //   ]
    // },
  ]
};

const debtors = {
  header: 'Работа с должниками',
  items: [
    {
      title: 'Справочники',
      list: [
        {
          name: 'Дома для работы с должниками',
          route: { name: 'HousesOfDebtors' },
          permission: {
            controller: 'HousesOfDebtors',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Шаблоны',
          route: { name: 'DebtorTemplates' },
          permission: {
            controller: 'DebtorDocTemplates',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Виды комментариев по досудебной работе',
          route: { name: 'DebtCasesPreTrialWorksTypes' },
          permission: {
            controller: 'DebtCasesPreTrialWorksTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Судебные участки',
          route: { name: 'JudicialSectors' },
          permission: {
            controller: 'JudicialSectors',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Взыскатели',
          route: { name: 'Claimants' },
          permission: {
            controller: 'Claimants',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Типы взыскателей',
          route: { name: 'ClaimantsTypes' },
          permission: {
            controller: 'ClaimantsTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Пользователи для работы с должниками',
          route: { name: 'UsersForDebtors' },
          permission: {
            controller: 'UsersForDebtors',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Этапы работы',
          route: { name: 'DebtProceedingStages' },
          permission: {
            controller: 'DebtProceedingStages',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Формирование дел должников',
      list: [
        {
          name: 'Исполнители по делам должников',
          route: { name: 'AutoDebtCaseDispatchers' },
          permission: {
            controller: 'AutoDebtCaseDispatchers',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Отчеты',
      list: [
        {
          name: 'Должники по периодам',
          route: { name: 'DebtorsByPeriods' },
          permission: {
            controller: 'DebtorsByPeriods',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет должники по периодам',
          route: { name: 'DebtorsByPeriodsReport' },
          permission: { controller: 'Report', method: 'DebtorsByPeriodsReport', action: 'View' }
        },
        {
          name: 'Оплата по должникам',
          route: { name: 'DebtorsPaymentsReport' },
          permission: { controller: 'Report', method: 'DebtorsPaymentsReport', action: 'View' }
        },
        {
          name: 'Отчет по взыскателям (оплатам) за период',
          route: { name: 'ClaimantsReport' },
          permission: { controller: 'Report', method: 'ClaimantsReport', action: 'View' }
        },
        {
          name: 'База лицевых счетов (ведомость по должникам)',
          route: { name: 'DebtorsIdentsStatementReport' },
          permission: { controller: 'Report', method: 'DebtorsIdentsStatementReport', action: 'View' }
        },
        {
          name: 'Отчет по статусам работы с должниками',
          route: { name: 'DebtorsCasesStatusesReport' },
          permission: { controller: 'Report', method: 'DebtorsCasesStatusesReport', action: 'View' }
        },
        {
          name: 'Отчет по эффективности автообзвонов',
          route: { name: 'DebtorsInformingEffectivenessReport' },
          permission: { controller: 'Report', method: 'DebtorsInformingEffectivenessReport', action: 'View' }
        }
      ]
    },
    {
      title: 'Обработки',
      list: [
        {
          name: 'База лицевых счетов (ведомость по должникам)',
          route: { name: 'DebtorsIdentsStatementReportProcessor' },
          permission: { controller: 'Processor', method: 'DebtorsIdentsStatementReportProcessor', action: 'Perform' }
        },
        {
          name: 'Формирование дел должников',
          route: { name: 'CreateDebtCasesWithRequestProcessor' },
          permission: { controller: 'Processor', method: 'CreateDebtCasesWithRequestProcessor', action: 'Perform' }
        },
        {
          name: 'Загрузка дел должников из файла',
          route: { name: 'ImportDebtorsCases' },
          permission: { controller: 'Processor', method: 'ImportDebtorsCases', action: 'Perform' }
        }
      ]
    },
    {
      title: 'Общие справочники',
      list: [
        // {
        //   name: 'Организации',
        //   route: { name: 'CompanyProfile' },
        //   permission: {
        //     controller: 'CompanyProfile',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Дома',
          route: { name: 'DebtorRelationsHouses' },
          permission: {
            controller: 'Houses',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Лицевые счета',
          route: { name: 'DebtorRelations.Accounts' },
          permission: {
            controller: 'Accounts',
            method: 'Table',
            action: 'View'
          }
        },
        // {
        //   name: 'Платежи',
        //   route: { name: 'DebtorRelationsPaymentsInfo' },
        //   permission: {
        //     controller: 'PaymentsInfo',
        //     method: 'Table',
        //     action: 'View'
        //   }
        // },
        {
          name: 'Квитанции',
          route: { name: 'DebtorRelationsBills' },
          permission: {
            controller: 'Bills',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Пользователи',
          route: { name: 'AccessUsers' },
          permission: {
            controller: 'Users',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Оборотно-сальдовые ведомости',
      list: [
        {
          name: 'Загрузка Оборотно-сальдовых ведомостей по услугам по форме 1.18',
          route: { name: 'ImportServiceTrialBalanceForm118Processor' },
          permission: {
            controller: 'ImportServiceTrialBalanceForm118Processor',
            method: 'Processor',
            action: 'Perform',
          }
        },
        {
          name: 'Загрузка Оборотно-сальдовых ведомостей по услугам по форме 80.10.06',
          route: { name: 'ImportServiceTrialBalanceForm801006Processor' },
          permission: {
            controller: 'ImportServiceTrialBalanceForm801006Processor',
            method: 'Processor',
            action: 'Perform',
          }
        },
        {
          name: 'Загрузка Оборотно-сальдовых ведомостей по услугам из квитанций',
          route: { name: 'ImportServiceTrialBalanceFormBillsProcessor' },
          permission: {
            controller: 'ImportServiceTrialBalanceFormBillsProcessor',
            method: 'Processor',
            action: 'Perform',
          }
        },
        {
          name: 'Просмотр Оборотно-сальдовых ведомостей по услугам',
          route: { name: 'ServiceTrialBalance' },
          permission: {
            controller: 'ServiceTrialBalance',
            method: 'Table',
            action: 'View',
          }
        },
        {
          name: 'Отчет по оборотно-сальдовым ведомостям по услугам',
          route: { name: 'ServiceTrialBalanceReport' },
          permission: {
            controller: 'ServiceTrialBalanceReport',
            method: 'Report',
            action: 'View',
          }
        },
      ]
    },
    {
      title: 'Дела должников',
      list: [
        {
          name: 'Список дел должников',
          route: { name: 'DebtList' },
          permission: {
            controller: 'DebtorCasePage',
            method: 'Table',
            action: 'View'
          }
        },
      ]
    },
  ]
};

const electronicControlRoom = {
  header: 'Электронная диспетчерская (Меню)',
  items: [
    {
      title: 'Заявки',
      list: [
        {
          name: 'Типы источника заявок',
          route: { name: 'RequestSourceTypes' },
          permission: {
            controller: 'RequestSourceTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Типы заявок',
          route: { name: 'ElectronicControlRoom.RequestTypes' },
          permission: {
            controller: 'RequestTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Группы типа заявок',
          route: { name: 'RequestTypeGroups' },
          permission: {
            controller: 'RequestTypeGroups',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Виды неисправностей',
          route: { name: 'ElectronicControlRoom.MalfunctionTypes' },
          permission: {
            controller: 'MalfunctionTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Подробные виды неисправностей',
          route: { name: 'ElectronicControlRoom.DetailedMalfunctionTypes' },
          permission: {
            controller: 'DetailedMalfunctionTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Подразделения',
          route: { name: 'Divisions' },
          permission: {
            controller: 'Divisions',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Пулы заявок',
          route: { name: 'RequestPools' },
          permission: {
            controller: 'RequestPools',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Email-источников заявок',
          route: { name: 'EmailGates' },
          permission: {
            controller: 'EmailGates',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Email правила фильтрации',
          route: { name: 'EmailGateFilters' },
          permission: {
            controller: 'EmailGateFilters',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Темы обращений к директору в Телеграм',
          route: { name: 'ElectronicControlRoom.ToShareholderTelegramSubjects' },
          permission: {
            controller: 'ToShareholderTelegramSubjects',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Группы для отправки аварийных заявок',
          route: { name: 'EmergencyRequestChannels' },
          permission: {
            controller: 'EmergencyRequestChannels',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Информация в помощь диспетчеру',
          route: { name: 'HelpDispatcherGeneral' },
          permission: {
            controller: 'HelpDispatcherGeneralInfo',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'График работы сотрудников',
          route: { name: 'EmploymentCalendar' },
          permission: {
            controller: 'EmploymentCalendar',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Настройки для автоперевода заявок',
          route: { name: 'ElectronicControlRoom.AutoMoveSettings' },
          permission: {
            controller: 'AutoMoveSettings',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Настройки автоподключения к просроченным заявкам',
          route: { name: 'ElectronicControlRoom.AutoSubscriptionForOverdue' },
          permission: {
            controller: 'AutoSubscriptionForOverdue',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Автоматически подключаемые к заявке наблюдатели',
          route: { name: 'AutoObserversSettings' },
          permission: {
            controller: 'AutoObserversSettings',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Настройки автоперевода заявок с низкой оценкой',
          route: { name: 'ElectronicControlRoom.AutoMoveLowMark' },
          permission: {
            controller: 'AutoMoveLowMark',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Дополнительные поля заявок',
          route: { name: 'ElectronicControlRoom.RequestAdditionalFields' },
          permission: {
            controller: 'RequestAdditionalFields',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Типы задач',
          route: { name: 'TaskTypes' },
          permission: {
            controller: 'TaskTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Настраиваемые отборы заявок',
          route: { name: 'CustomizableSelections' },
          permission: {
            controller: 'CustomizableSelections',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Аварийные работы',
          route: { name: 'EmergencyWorks' },
          permission: {
            controller: 'EmergencyWorks',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Звонки',
      list: [
        {
          name: 'Журнал звонков',
          route: { name: 'Calls' },
          permission: {
            controller: 'Calls',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Пропущенные звонки',
          route: { name: 'MissedCalls' },
          permission: {
            controller: 'MissedCalls',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Общий список пользователей телефонии',
          route: { name: 'VoipUsersCommonList' },
          permission: {
            controller: 'VoipUsersCommonList',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Параметры входящих номеров по событиям от АТС',
          route: { name: 'SupportAcceptorPhones' },
          permission: {
            controller: 'SupportAcceptorPhones',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Адреса',
      list: [
        {
          name: 'Дивизионы групп районов',
          route: { name: 'ElectronicControlRoomDistrictDivisions' },
          permission: {
            controller: 'DistrictDivisions',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Группы районов',
          route: { name: 'ElectronicControlRoomGroupsOfDistricts' },
          permission: {
            controller: 'GroupsOfDistricts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Районы',
          route: { name: 'ElectronicControlRoomHomeGroups' },
          permission: {
            controller: 'HomeGroups',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Лицевые счета',
          route: { name: 'ElectronicControlRoom.Accounts' },
          permission: {
            controller: 'Accounts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Дома',
          route: { name: 'ElectronicControlRoomHouses' },
          permission: { 
            controller: 'Houses', 
            method: 'Table', 
            action: 'View'
          }
        },
        {
          name: 'Помещения',
          route: { name: 'ElectronicControlRoom.Premises' },
          permission: {
            controller: 'Premises',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Комнаты',
          route: { name: 'ElectronicControlRoom.Rooms' },
          permission: {
            controller: 'Rooms',
            method: 'Table',
            action: 'View'
          }
        },
      ]
      //     {
      //       name: 'Дома, обслуживаемые КЦ',
      //       route: { name: 'HousesServicedByCC' },
      //       controllerName: 'HousesServicedByCC',
      //     },
      //   ],
    },
    {
      title: 'Аналитические отчеты',
      list: [
        {
          name: 'Информация в помощь диспетчеру',
          route: { name: 'HelpDispatcherInfoReport' },
          permission: {
            controller: 'HelpDispatcherInfoReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Журнал заявок',
          route: { name: 'AdsJournalReport' },
          permission: {
            controller: 'AdsJournalReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Журнал заявок (вариант 2)',
          route: { name: 'AdsJournalCapitalInvestReport' },
          permission: {
            controller: 'AdsJournalCapitalInvestReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по платным заявкам',
          route: { name: 'PaidRequestsReport' },
          permission: {
            controller: 'PaidRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Журнал отключения коммунальных ресурсов',
          route: { name: 'UtilityShutdownsReport' },
          permission: {
            controller: 'UtilityShutdownsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по задачам',
          route: { name: 'TasksReport' },
          permission: {
            controller: 'TasksReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Анализ поступивших заявок',
          route: { name: 'AdsAnaliticalReport' },
          permission: {
            controller: 'AdsAnaliticalReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по обращениям к директору в телеграм',
          route: { name: 'MessagesToShareholderTelegramReport' },
          permission: {
            controller: 'MessagesToShareholderTelegramReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Жалобы и обращения',
          route: { name: 'AdsYammerRequestsReport' },
          permission: {
            controller: 'AdsYammerRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Статистика звонков',
          route: { name: 'AdsCallsStatisticsReport' },
          permission: {
            controller: 'AdsCallsStatisticsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Заявки по исполнителям',
          route: { name: 'AdsRequestsPerformingReport' },
          permission: {
            controller: 'AdsRequestsPerformingReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Мои выполненные заявки за период',
          route: { name: 'AdsMyPerformedJournalReport' },
          permission: {
            controller: 'AdsMyPerformedJournalReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Оценка удовлетворенности',
          route: { name: 'AdsMarksOverviewReport' },
          permission: {
            controller: 'AdsMarksOverviewReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по поступившим обращениям в диспетчерскую службу',
          route: { name: 'AdsIncomingRequestsReport' },
          permission: {
            controller: 'AdsIncomingRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по источнику заявок за период',
          route: { name: 'EdsMoIncomingRequestsReport' },
          permission: { 
            controller: 'EdsMoIncomingRequestsReport', 
            method: 'Report', 
            action: 'View'
          },
        },
        {
          name: 'Журнал оформленных заявок на пропуск',
          route: { name: 'AdsPassJournalReport' },
          permission: {
            controller: 'AdsPassJournalReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по пропущенным звонкам',
          route: { name: 'AdsMissedCallReport' },
          permission: {
            controller: 'AdsMissedCallReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по расходованию материалов',
          route: { name: 'MaterialsConsumptionReport' },
          permission: {
            controller: 'MaterialsConsumptionReport',
            method: 'Report',
            action: 'View'
          }
        },
        // {
        //   name: 'Отчет по геолокации сотрудников',
        //   route: { name: 'SupportDispatchersGeolocating' }
        // },
        // TODO: Кастомный отчет
        // {
        //   name: 'Отчет по геолокации сотрудников',
        //   route: { name: 'AdsEmployeeGeolocation' },
        // },
        {
          name: 'Эксперт отчет по заявкам, подразделениям',
          route: { name: 'RequestDivisionReport' },
          permission: {
            controller: 'RequestDivisionReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Эксперт отчет по услугам',
          route: { name: 'SpecifiedServicesReport' },
          permission: {
            controller: 'SpecifiedServicesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Эксперт отчет заявки по датам',
          route: { name: 'RequestDateReport' },
          permission: {
            controller: 'RequestDateReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Эксперт отчет по звонкам',
          route: { name: 'CallsReport' },
          permission: {
            controller: 'CallsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по обзвонам робота-оценщика',
          route: { name: 'AskForMarkCallsReport' },
          permission: {
            controller: 'AskForMarkCallsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Реестр телефонограмм',
          route: { name: 'PhonogramsReport' },
          permission: {
            controller: 'PhonogramsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Лицевые счета, получающие квитанции в эл. виде',
          route: { name: 'IdentsWithElectronicBillsReport' },
          permission: {
            controller: 'IdentsWithElectronicBillsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Лицевые счета, изменившие галку согласия получать квитанции в электронном виде',
          route: { name: 'IdentsWithElectronicBillsChangesReport' },
          permission: {
            controller: 'IdentsWithElectronicBillsChangesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по дедлайну',
          route: { name: 'DeadlineReport' },
          permission: {
            controller: 'DeadlineReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Телефоны из заявок',
          route: { name: 'AdsRequestsPhonesReport' },
          permission: {
            controller: 'AdsRequestsPhonesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Отчет по результатам работы нейросети',
          route: { name: 'NeuralNetworkTypesReport' },
          permission: {
            controller: 'NeuralNetworkTypesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Прием-передача помещений',
          route: { name: 'AcceptanceActsRequestsReport' },
          permission: {
            controller: 'AcceptanceActsRequestsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Настройки автоперевода заявок',
          route: { name: 'AutoMoveSettingsReport' },
          permission: {
            controller: 'Report',
            method: 'AutoMoveSettingsReport',
            action: 'View'
          }
        },
        {
          name: 'Отчет по отправленным комментариям жителям',
          route: { name: 'AdsRepliesToResidentReport' },
          permission: {
            controller: 'Report',
            method: 'AdsRepliesToResidentReport',
            action: 'View'
          }
        },
        // {
        //   name: 'Тестовый отчет с мультивыбором',
        //   route: { name: 'TestMultiSelectReport' }
        // },
      ]
    },
    {
      title: 'Объекты контроля',
      list: [
        {
          name: 'Объекты контроля',
          route: { name: 'ElectronicControlRoom.ControlObjects' },
          permission: {
            controller: 'ControllObjects',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Настройка чек-листа приемки',
          route: { name: 'ElectronicControlRoom.AcceptanceCheckLists' },
          permission: {
            controller: 'AcceptanceCheckList',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Настройки',
      list: [
        {
          name: 'Настройки диспетчерской службы',
          route: { name: 'ElectronicControlRoom.SupportSettings' },
          permission: {
            controller: 'Support',
            method: 'Settings',
            action: 'Edit'
          }
        },
        {
          name: 'Комментарии к телефонным номерам',
          route: { name: 'PhonesComments' },
          permission: {
            controller: 'PhonesComments',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Ежедневное расписание работы',
          route: { name: 'DailyWorkSchedule' },
          permission: {
            controller: 'DailyWorkSchedule',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Управление пользователями',
      list: [
        {
          name: 'Пользователи',
          route: { name: 'Users' },
          permission: {
            controller: 'Users',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по последней активности пользователей сотрудников',
          route: { name: 'LastUsersActivityReport' },
          permission: {
            controller: 'LastUsersActivityReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Группы домов',
          route: { name: 'HouseGroups' },
          permission: {
            controller: 'HouseGroups',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Управление пропусками',
      list: [
        {
          name: 'Пропуска',
          route: { name: 'Passes' },
          permission: {
            controller: 'HouseGroups',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Категории пропусков',
          route: { name: 'PassCategories' },
          permission: {
            controller: 'PassCategories',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Шаблоны номеров автотранспорта',
          route: { name: 'VehicleNumberTemplates' },
          permission: {
            controller: 'VehicleNumberTemplates',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Марки автомобилей',
          route: { name: 'VehicleMarks' },
          permission: {
            controller: 'VehicleMarks',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Черный список автотранспорта',
          route: { name: 'BlackListCarNumbers' },
          permission: {
            controller: 'BlackListCarNumbers',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Черный список лицевых счетов',
          route: { name: 'BlackListIdents' },
          permission: {
            controller: 'BlackListIdents',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Загрузка марок автомобилей',
          route: { name: 'ImportVehicleMarks' },
          permission: {
            controller: 'ImportVehicleMarks',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Загрузка черного списка автотранспорта',
          route: { name: 'ImportBlacklistCarNumbers' },
          permission: {
            controller: 'ImportBlacklistCarNumbers',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Загрузка черного списка лицевых счетов',
          route: { name: 'ImportBlackListIdents' },
          permission: {
            controller: 'ImportBlackListIdents',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Документооборот',
      list: [
        {
          name: 'Типы документов',
          route: { name: 'DocumentTypes' },
          permission: {
            controller: 'DocumentTypes',
            method: 'Table',
            action: 'View'
          }
        },
      ]
    },
    {
      title: 'Шаблоны',
      list: [
        {
          name: 'Шаблонные ответы диспетчера',
          route: { name: 'SupportPatternTexts' },
          permission: {
            controller: 'SupportPatternTexts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Шаблоны уведомлений',
          route: { name: 'SupportNotificationTemplates' },
          permission: {
            controller: 'SupportNotificationTemplates',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Шаблоны документов',
          route: { name: 'AdsDocTemplates' },
          permission: {
            controller: 'AdsDocTemplates',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Как создать шаблон?',
          route: { name: 'AdsDocsHowCreateTemplate' }
        }
        //     {
        //       name: 'Как создать шаблон?',
        //       route: { name: 'AdsDocsHowCreateTemplate' },
        //       controllerName: 'AdsDocsHowCreateTemplate',
        //     },
      ]
    },
    {
      title: 'Телефонограммы',
      list: [
        {
          name: 'Типы телефонограмм',
          route: { name: 'PhonogramTypes' },
          permission: {
            controller: 'PhonogramTypes',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Работы и материалы',
      list: [
        {
          name: 'Типы материалов',
          route: { name: 'MaterialTypes' },
          permission: {
            controller: 'MaterialTypes',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Приход материалов',
          route: { name: 'MaterialJournal' },
          permission: {
            controller: 'MaterialJournal',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Список работ',
          route: { name: 'ElectronicControlRoom.ListOfWorks' },
          permission: {
            controller: 'ListOfWorks',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Интеграция с внешними системами',
      list: [
        {
          name: 'Периодические задачи обмена с ГИС ЖКХ и ЕДС МО',
          route: { name: 'Integration.GisAdsAutoTaskPack' },
          permission: {
            controller: 'GisAdsAutoTaskPack',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Маршрутизация',
      list: [
        {
          name: 'Маршруты заявок',
          route: { name: 'ElectronicControlRoom.RequestsRoutes' },
          permission: {
            controller: 'RequestsRoutes',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Севрисы с записью',
      list: [
        {
          name: 'Сервисы с записью',
          route: { name: 'ServicesWithRecording' },
          permission: {
            controller: 'ServicesWithRecording',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Статистика по сервисам с записью',
          route: { name: 'ServicesWithRecordingReport' },
          permission: {
            controller: 'ServicesWithRecordingReport',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по журналу записи',
          route: { name: 'ServicesWithRecordingJournalReport' },
          permission: {
            controller: 'ServicesWithRecordingJournalReport',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
  ]
};

const interactiveAccess = {
  header: 'СКУД',
  items: [
    {
      title: 'Объекты СКУД',
      list: [
        {
          name: 'Объекты СКУД',
          route: { name: 'InteractiveAccessObjects' },
          permission: {
            controller: 'InteractiveAccessObjects',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Серверы СКУД',
          route: { name: 'InteractiveAccessObjectServers' },
          permission: {
            controller: 'InteractiveAccessObjectServers',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Типы объектов СКУД',
          route: { name: 'InteractiveAccessObjectTypes' },
          permission: {
            controller: 'InteractiveAccessObjectTypes',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Камеры',
      list: [
        {
          name: 'Видеорегистраторы',
          route: { name: 'VideoRecorders' },
          permission: {
            controller: 'VideoRecorders',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Камеры домов',
          route: { name: 'HouseCameras' },
          permission: {
            controller: 'HouseCameras',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Группы камер и объектов доступа',
          route: { name: 'ObjectGroups' },
          permission: {
            controller: 'ObjectGroups',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по доступности камер',
          route: { name: 'WebCamsAvailabilityReport' },
          permission: {
            controller: 'WebCamsAvailabilityReport',
            method: 'Report',
            action: 'View'
          }
        },
      ]
    },
    {
      title: 'Пользователи',
      list: [
        {
          name: 'Пользователи объектов доступа',
          route: { name: 'PremisesIntercoms' },
          permission: {
            controller: 'PremisesIntercoms',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Загрузка пользователей объектов доступа',
          route: { name: 'ImportPremisesIntercoms' },
          permission: {
            controller: 'ImportPremisesIntercoms',
            method: 'Import',
            action: 'Perform'
          }
        },
      ]
    },
    {
      title: 'Журналы',
      list: [
        {
          name: 'Журнал активации объектов СКУД',
          route: { name: 'InteractiveAccessObjectsActivationsLog' },
          permission: {
            controller: 'InteractiveAccessObjectsActivationsLog',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Статистика ошибок активации объектов СКУД',
          route: { name: 'InteractiveAccess.InteractiveObjectActivateErrorStatisticReport' },
          permission: {
            controller: 'InteractiveObjectActivateErrorStatisticReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Журнал вызовов домофона',
          route: { name: 'InteractiveAccessObjectsPushLog' },
          permission: {
            controller: 'InteractiveAccessObjectsPushLog',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Выданные права доступа',
          route: { name: 'DelegatedRights' },
          permission: {
            controller: 'DelegatedRights',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Информация о событиях пользователя',
          route: { name: 'UserLogInformation' },
          permission: {
            controller: 'UserLogInformation',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Информация о событиях пользователя (с фильтром для аналитики)',
          route: { name: 'UserLogAnalitic' },
          permission: {
            controller: 'UserLogAnalitic',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Отчет по журналу звонков',
          route: { name: 'InteractiveAccess.UserLogAnaliticReport' },
          permission: {
            controller: 'UserLogAnaliticReport',
            method: 'Report',
            action: 'View'
          }
        },
      ]
    },
    {
      title: 'АТС',
      list: [
        {
          name: 'Аккаунты АТС домофонов',
          route: { name: 'InteractiveAccess.AtsIntercomsReport' },
          permission: {
            controller: 'AtsIntercomsReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Аккаунты АТС помещений',
          route: { name: 'InteractiveAccess.AtsPremisesReport' },
          permission: {
            controller: 'AtsPremisesReport',
            method: 'Report',
            action: 'View'
          }
        },
        {
          name: 'Телефония',
          route: { name: 'InteractiveAccess.AtsFillPremisesByHouseProcessor' },
          permission: {
            controller: 'AtsFillPremisesByHouseProcessor',
            method: 'Processor',
            action: 'Perform'
          }
        },
      ],
    },
    {
      title: 'Списки собственников',
      list: [
        {
          name: 'Дивизионы групп районов',
          route: { name: 'InteractiveAccessDistrictDivisions' },
          permission: {
            controller: 'DistrictDivisions',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Группы районов',
          route: { name: 'InteractiveAccessGroupsOfDistricts' },
          permission: {
            controller: 'GroupsOfDistricts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Районы',
          route: { name: 'InteractiveAccessHomeGroups' },
          permission: {
            controller: 'HomeGroups',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Дома',
          route: { name: 'InteractiveAccessHouses' },
          permission: {
            controller: 'Houses',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Помещения',
          route: { name: 'InteractiveAccessPremises' },
          permission: {
            controller: 'Premises',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Лицевые счета',
          route: { name: 'InteractiveAccess.Accounts' },
          permission: {
            controller: 'Accounts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Мобильные пользователи',
          route: { name: 'InteractiveAccess.MobileAccounts' },
          permission: {
            controller: 'MobileAccounts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Устройства',
          route: { name: 'InteractiveAccess.DevicesForMobileAccount' },
          permission: {
            controller: 'MobileAccountDevices',
            method: 'Table',
            action: 'View'
          }
        },
      ]
    },
    {
      title: 'Настройки',
      list: [
        {
          name: 'Настройки СКУД',
          route: { name: 'InteractiveAccess.ObjectsSettings' },
          permission: {
            controller: 'InteractiveAccessObjects',
            method: 'Settings',
            action: 'Edit'
          }
        },
      ],
    },
  ]
  // {
  //   title: 'Обработки', // ТОЛЬКО ВЛОЖЕННЫЕ
  //   list: [
  //     {
  //       name: 'Записать данные АТС в помещения',
  //       route: { name: 'AtsFillPremisesByHouseProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'AtsFillPremisesByHouseProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Экспорт номеров помещений ГИС в Excel',
  //       route: { name: 'ExportPremiseGisNumberProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'ExportPremiseGisNumberProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Обновить ИЖКУ по результатам обработки шаблона ЛС ТКО',
  //       route: { name: 'InteractiveAccess.AccountFromTkoTemplateProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'AccountFromTkoTemplateProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Выгрузить ЛС/ЕЛС в CSV',
  //       route: { name: 'InteractiveAccess.AccountsCsvFileProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'AccountsCsvFileProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Выгрузить ЛС/ЕЛС в Excel',
  //       route: { name: 'InteractiveAccess.AccountsExcelFileProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'AccountsExcelFileProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Создать лицевые счета для кап.ремонта',
  //       route: { name: 'InteractiveAccess.CreateCRAccountsProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'CreateCRAccountsProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Выгрузить доп. информацию по домам (XLSX)',
  //       route: { name: 'InteractiveAccess.ExportHousesToExcelProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'ExportHousesToExcelProcessor',
  //         action: 'View'
  //       }
  //     },
  //     {
  //       name: 'Выгрузить дома без ФИАС в CSV файл',
  //       route: { name: 'InteractiveAccess.ExportHousesWithoutFiasProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'ExportHousesWithoutFiasProcessor',
  //         action: 'View'
  //       }
  //     },
  //     {
  //       name: 'Выгрузить ЛС ТКО',
  //       route: { name: 'InteractiveAccess.FillTemplateTKOAccountsProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'FillTemplateTKOAccountsProcessor',
  //         action: 'View'
  //       }
  //     },
  //     {
  //       name: 'Мастер создания дома',
  //       route: { name: 'InteractiveAccess.HouseCreationMasterProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'HouseCreationMasterProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Загрузить ФИАСы',
  //       route: { name: 'InteractiveAccess.HouseFiasesProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'HouseFiasesProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Заполнить шаблон по добавлению ОЖФ в договор ТКО(XLSX)',
  //       route: { name: 'InteractiveAccess.HousesForTkoContractProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'HousesForTkoContractProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Изменение типа домов по кол-ву помещений',
  //       route: { name: 'InteractiveAccess.HouseTypeByPremiseTypeProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'HouseTypeByPremiseTypeProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Загрузить доп. информацию по домам (XLSX)',
  //       route: { name: 'InteractiveAccess.ImportHousesFromExcelProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'ImportHousesFromExcelProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Удалить помещения, не привязанные к ЛС',
  //       route: { name: 'InteractiveAccess.PremisesNotLinkedToAccountRemoveProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'PremisesNotLinkedToAccountRemoveProcessor',
  //         action: 'View',
  //       }
  //     },
  //     {
  //       name: 'Обновление адресов домов',
  //       route: { name: 'InteractiveAccess.UpdateHousesAddressesProcessor' },
  //       permission: {
  //         controller: 'Processor',
  //         method: 'UpdateHousesAddressesProcessor',
  //         action: 'View',
  //       }
  //     },
  //   ]
  // },
};

const siteCompany = {
  header: 'Сайт компании ЖКХ',
  items: [
    {
      title: 'Параметры сайта',
      list: [
        {
          name: 'Общие настройки',
          route: { name: 'SiteSettings' },
          permission: {
            controller: 'Site',
            method: 'Settings',
            action: 'Edit'
          }
        },
        {
          name: 'Дополнительные параметры',
          route: { name: 'AdditionalOptions' },
          permission: {
            controller: 'AdditionalOptions',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Партнерские ссылки на сайте',
          route: { name: 'SitePartnerLinks' },
          permission: {
            controller: 'SitePartnerLinks',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Наполнение сайта',
      list: [
        {
          name: 'Новости',
          route: { name: 'News' },
          permission: {
            controller: 'News',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Каналы уведомлений',
          route: { name: 'NotificationChannels' },
          permission: {
            controller: 'NotificationChannels',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Частые вопросы и ответы',
          route: { name: 'FAQ' },
          permission: {
            controller: 'FAQ',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Документы',
          route: { name: 'Documents' },
          permission: {
            controller: 'Documents',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Группы Документов',
          route: { name: 'DocumentGroups' },
          permission: {
            controller: 'GroupDocuments',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Статьи',
          route: { name: 'Articles' },
          permission: {
            controller: 'Articles',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Фотоотчеты',
          route: { name: 'PhotoReports' },
          permission: {
            controller: 'PhotoReports',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Файлы',
          route: { name: 'Files' },
          permission: {
            controller: 'Files',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'О компании',
          route: { name: 'AboutCompany', params: { id: 1 } },
          permission: {
            controller: 'About',
            method: 'Company',
            action: 'Edit'
          }
        },
        {
          name: 'Дома',
          route: { name: 'SiteCompany.Houses' },
          permission: {
            controller: 'Houses',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Галерея',
      list: [
        {
          name: 'Альбомы',
          route: { name: 'GalleryAlbums' },
          permission: {
            controller: 'GalleryAlbums',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Изображения',
          route: { name: 'GalleryImages' },
          permission: {
            controller: 'GalleryImages',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Видео',
          route: { name: 'GalleryVideos' },
          permission: {
            controller: 'GalleryVideos',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    },
    {
      title: 'Меню (новый сайт)',
      list: [
        {
          name: 'Меню',
          route: { name: 'SiteMenuItems' },
          permission: {
            controller: 'SiteMenuItems',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    }
  ]
};

const oneC = {
  header: '1С',
  items: [
    {
      title: 'Справочники',
      list: [
        {
          name: 'Список информационных баз 1С',
          route: { name: 'OneC.Bases' },
          permission: {
            controller: 'Bases1c',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Архив информационных баз 1С',
          route: { name: 'OneC.Archives' },
          permission: {
            controller: 'Archives',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Список пользователей',
          route: { name: 'OneC.Users' },
          permission: {
            controller: 'Users1c',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Профили пользователей',
          route: { name: 'OneC.Profiles' },
          permission: {
            controller: 'Profiles',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Доступы пользователей в базы 1С',
          route: { name: 'OneC.UsersAccess' },
          permission: {
            controller: 'Users1cAccess',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Договоры',
          route: { name: 'OneC.Contracts' },
          permission: {
            controller: 'Contracts',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Счета на оплату',
          route: { name: 'OneC.Bills' },
          permission: {
            controller: 'Bills',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Оплаты',
          route: { name: 'OneC.Payments' },
          permission: {
            controller: 'Payments',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Акты оказанных услуг',
          route: { name: 'OneC.Acts' },
          permission: {
            controller: 'Acts',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    }
    // {
    //   title: 'Обработки', // ТОЛЬКО ВЛОЖЕННЫЕ
    //   list: [
    //     {
    //       name: 'Выгрузить доп. информацию по домам (XLSX)',
    //       route: { name: 'SiteCompany.ExportHousesToExcelProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'ExportHousesToExcelProcessor',
    //         action: 'View'
    //       }
    //     },
    //     {
    //       name: 'Выгрузить дома без ФИАС в CSV файл',
    //       route: { name: 'SiteCompany.ExportHousesWithoutFiasProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'ExportHousesWithoutFiasProcessor',
    //         action: 'View'
    //       }
    //     },
    //     {
    //       name: 'Мастер создания дома',
    //       route: { name: 'SiteCompany.HouseCreationMasterProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'HouseCreationMasterProcessor',
    //         action: 'View',
    //       }
    //     },
    //     {
    //       name: 'Загрузить ФИАСы',
    //       route: { name: 'SiteCompany.HouseFiasesProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'HouseFiasesProcessor',
    //         action: 'View',
    //       }
    //     },
    //     {
    //       name: 'Заполнить шаблон по добавлению ОЖФ в договор ТКО(XLSX)',
    //       route: { name: 'SiteCompany.HousesForTkoContractProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'HousesForTkoContractProcessor',
    //         action: 'View',
    //       }
    //     },
    //     {
    //       name: 'Изменение типа домов по кол-ву помещений',
    //       route: { name: 'SiteCompany.HouseTypeByPremiseTypeProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'HouseTypeByPremiseTypeProcessor',
    //         action: 'View',
    //       }
    //     },
    //     {
    //       name: 'Загрузить доп. информацию по домам (XLSX)',
    //       route: { name: 'SiteCompany.ImportHousesFromExcelProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'ImportHousesFromExcelProcessor',
    //         action: 'View',
    //       }
    //     },
    //     {
    //       name: 'Удалить помещения, не привязанные к ЛС',
    //       route: { name: 'SiteCompany.PremisesNotLinkedToAccountRemoveProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'PremisesNotLinkedToAccountRemoveProcessor',
    //         action: 'View',
    //       }
    //     },
    //     {
    //       name: 'Обновление адресов домов',
    //       route: { name: 'SiteCompany.UpdateHousesAddressesProcessor' },
    //       permission: {
    //         controller: 'Processor',
    //         method: 'UpdateHousesAddressesProcessor',
    //         action: 'View',
    //       }
    //     },
    //   ]
    // },
  ]
};

const access = {
  header: 'Доступы',
  items: [
    {
      title: '',
      list: [
        {
          name: 'Пользователи',
          route: { name: 'Access.Users' },
          permission: {
            controller: 'Users',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Пользователи АДС',
          route: { name: 'Access.AdsUsers' },
          permission: {
            controller: 'Users',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Роли сотрудников в базе',
          route: { name: 'Access.Roles' },
          permission: {
            controller: 'Roles',
            method: 'Table',
            action: 'View'
          }
        }
      ]
    }
  ]
};

/* const settlementCenter = {
  header: 'Расчетный центр',
  items: [
    {
      title: '',
      list: [
        {
          name: 'Форма ввода показаний ИПУ',
          route: { name: 'SettlementCenter.IndividualMeterValuesInputForm' },
          permission: {
            controller: 'IndividualMeterValuesInputForm',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Форма ввода показаний ОДПУ',
          route: { name: 'SettlementCenter.HouseMeterValuesInputForm' },
          permission: {
            controller: 'HouseMeterValuesInputForm',
            method: 'Table',
            action: 'View'
          }
        },
      ],
    },
    {
      title: 'Квитанции',
      list: [
        {
          name: 'Настройки формирования квитанций',
          route: { name: 'SettlementCenter.ReceiptGenerationSettings' },
          permission: {
            controller: 'ReceiptGenerationSettings',
            method: 'Table',
            action: 'View'
          }
        },
        {
          name: 'Генерация pdf-квитанций',
          route: { name: 'SettlementCenter.CreateBillsPdfProcessor' },
          permission: {
            controller: 'CreateBillsPdfProcessor',
            method: 'Processor',
            action: 'Perform'
          }
        },
      ],
    },
  ],
}; */

export default {
  //settlementCenter,
  debtors,
  electronicControlRoom,
  ownersOffices,
  gis,
  interactiveAccess,
  siteCompany,
  oneC,
  access
};
